import React from "react";
import Title from "../../../../Universal/Title.component";
import LineChart from "../../../../Universal/LineChart.component";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import GraphToolTip from "../../../../Universal/GraphLegends.component";
const TuitionCard = ({ attendanceData, headerBtnAction, handelTuition }) => {
  const chartColor = {
    key1: "#867EC6",
    key2: "#FFB700",
  };

  return (
    <div className="flex-col align-start justify-start radius-6 back-white w-fit p-2 g-2">
      <div className="flex-row align-center justify-between">
        <Title>Class 5/A</Title>
        <div className="flex-row align-center g-05">
          <span className="t-16 poppins">Students:</span>
          <span className="t-16 poppins color-greenColor">45</span>
        </div>
        <button className="actionBtn" onClick={headerBtnAction}>
          All students
        </button>
      </div>
      <div className="flex-row align-center jsutify-start g-1">
        <LineChart data={attendanceData} colors={chartColor} />
        <div className="flex-col align-start justify-start g-1 h-full">
          <SelectFilter />
          <div className="flex-col align-start justify-start">
            <GraphToolTip color={"#867EC6"} label={"Evening"} />
            <span className="t-10 color-grayColor">6:30 PM - 9:30 PM</span>
          </div>
          <div className="flex-col align-start justify-start">
            <GraphToolTip color={"#FFB700"} label={"Morning"} />
            <span className="t-10 color-grayColor">7:30 AM - 9:30 AM</span>
          </div>
          <div className="flex-col align-start justify-start"></div>
        </div>
      </div>

      <div className="flex-col align-start justify-start g-1">
        <Title style={{ width: "100%", textAlign: "center" }}>
          Morning shift
        </Title>
        <div className="flex-col align-start justify-start g-05">
          {/* teachers list  */}
          <div className="flex-row align-start justify-start g-2">
            <label htmlFor="teachers" className="t-13 poppins">
              Teachers:
            </label>
            <ul>
              <li className="t-13 color-greenColor poppins">Haider Ali</li>
              <li className="t-13 color-greenColor poppins">Haider Ali2</li>
            </ul>
          </div>
          {/* subjects list */}
          <div className="flex-row align-start justify-start g-2">
            <label htmlFor="teachers" className="t-13 poppins">
              Subjects:
            </label>
            <ul>
              <li className="t-13 color-greenColor poppins">
                Mathematics - Profit & Loss
              </li>
              <li className="t-13 color-greenColor poppins">
                English - Narrantion change
              </li>
            </ul>
          </div>
          {/* Best performer list */}
          <div className="flex-row align-start justify-start g-2">
            <label htmlFor="teachers" className="t-13 poppins">
              Best performer:
            </label>
            <ul>
              <li className="t-13 color-greenColor poppins">
                <span>Akbar Ali </span>{" "}
                <span style={{ color: "black" }}>[</span>
                <span>Mathematics</span>
                <span style={{ color: "black" }}>]</span>
              </li>
              <li className="t-13 color-greenColor poppins">
                <span>Hussain Raj </span>{" "}
                <span style={{ color: "black" }}>[</span>
                <span>English</span>
                <span style={{ color: "black" }}>]</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* details of section2  */}
      <div className="flex-col align-start justify-start g-1">
        <Title style={{ width: "100%", textAlign: "center" }}>
          Evening shift
        </Title>
        <div className="flex-col align-start justify-start g-05">
          {/* teachers list  */}
          <div className="flex-row align-start justify-start g-2">
            <label htmlFor="teachers" className="t-13 poppins">
              Teachers:
            </label>
            <ul>
              <li className="t-13 color-greenColor poppins">Haider Ali</li>
              <li className="t-13 color-greenColor poppins">Haider Ali2</li>
            </ul>
          </div>
          {/* subjects list */}
          <div className="flex-row align-start justify-start g-2">
            <label htmlFor="teachers" className="t-13 poppins">
              Subjects:
            </label>
            <ul>
              <li className="t-13 color-greenColor poppins">
                Mathematics - Profit & Loss
              </li>
              <li className="t-13 color-greenColor poppins">
                English - Narrantion change
              </li>
            </ul>
          </div>
          {/* Best performer list */}
          <div className="flex-row align-start justify-start g-2">
            <label htmlFor="teachers" className="t-13 poppins">
              Best performer:
            </label>
            <ul>
              <li className="t-13 color-greenColor poppins">
                <span>Akbar Ali </span>{" "}
                <span style={{ color: "black" }}>[</span>
                <span>Mathematics</span>
                <span style={{ color: "black" }}>]</span>
              </li>
              <li className="t-13 color-greenColor poppins">
                <span>Hussain Raj </span>{" "}
                <span style={{ color: "black" }}>[</span>
                <span>English</span>
                <span style={{ color: "black" }}>]</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <button className="actionBtn w-full" onClick={handelTuition}>
        Edit Details
      </button>
    </div>
  );
};

export default TuitionCard;
